import React from 'react';
import EditUsernamePopup from '../Popups/EditUsernamePopup';
import LoginOptionsPopup from '../Popups/LoginOptionsPopup';
import UserProfileDropdownPopup from '../Popups/UserProfileDropdownPopup';
import ConnectionStatus from './ConnectionStatus';
import 'reactjs-popup/dist/index.css';
import { RegisterOnUsernameChangeCallback, UnregisterOnUsernameChangeCallback, AttemptUserLoginFlow, LoginWithGoogle, LogoutUser, sessionUsername, sessionUserKarmaScore, sessionUserKarmaTotal, sessionUsernameChangesRemaining, sessionUserLoggedIn } from './LoginManager'
import { analytics } from './AnalyticsManager';

export default class TopBarUserProfilePanel extends React.Component
{
  state = {
    showDropdown: false,
    showEditUsernameOverlay: false,
    showLoginOverlay: false,
    connectionError: null
  };

  // Flag to prevent duplicate initialization in React Strict Mode
  isInitialized = false;

  async componentDidMount()
  {
    // Prevent duplicate initialization in React Strict Mode
    if( this.isInitialized )
    {
      return;
    }
    this.isInitialized = true;

    RegisterOnUsernameChangeCallback( this.onUsernameChanged );

    if( sessionUserLoggedIn )
    {
      return;
    }

    await AttemptUserLoginFlow(
      () =>
      {
        this.forceUpdate();
      },
      ( errorData ) =>
      {
        // Handle connection error
        if( errorData.isConnectionError )
        {
          this.setState( { connectionError: errorData } );
        }
      }
    );
  }

  async componentWillUnmount()
  {
    UnregisterOnUsernameChangeCallback( this.onUsernameChanged );
  }

  onUsernameChanged = ( newUsername ) =>
  {
    this.forceUpdate();
  }

  onEditUsernameRequested = () =>
  {
    this.setState( { showEditUsernameOverlay: true } );

    analytics.track( 'editUsername' );
  }

  onUsernameChangeClosed = () =>
  {
    this.setState( { showEditUsernameOverlay: false } );
  }

  onLoginRequested = () =>
  {
    this.setState( { showLoginOverlay: true } );

    analytics.track( 'login' );
  }

  onLoginOverlayClosed = () =>
  {
    this.setState( { showLoginOverlay: false } );
  }

  onGoogleLogin = ( googleData ) =>
  {
    LoginWithGoogle( googleData, () =>
    {
      this.onLoginOverlayClosed();
      this.forceUpdate();
    } );
  }

  onAccountLogout = async () =>
  {
    analytics.track( 'logout' );

    await LogoutUser();

    await AttemptUserLoginFlow(
      () =>
      {
        this.forceUpdate();
      },
      ( errorData ) =>
      {
        // Handle connection error
        if( errorData.isConnectionError )
        {
          this.setState( { connectionError: errorData } );
        }
      }
    );
  }

  onRetryConnection = async () =>
  {
    this.setState( { connectionError: null } );

    await AttemptUserLoginFlow(
      () =>
      {
        this.forceUpdate();
      },
      ( errorData ) =>
      {
        // Handle connection error
        if( errorData.isConnectionError )
        {
          this.setState( { connectionError: errorData } );
        }
      }
    );
  }


  render()
  {
    const username = sessionUsername ? sessionUsername : "Loading...";
    const karmaScore = sessionUserKarmaScore;
    const karmaTotal = sessionUserKarmaTotal;

    // Show connection status if there's a connection error
    if( this.state.connectionError )
    {
      return (
        <div className="connection-status-bar">
          <div className="connection-status-content">
            <div className="connection-status-text">
              <span className="connection-status-icon">⚠️</span>
              { this.state.connectionError.content }
            </div>
            <button
              className="connection-status-refresh-btn"
              onClick={ this.onRetryConnection }
            >
              Try Again
            </button>
          </div>
        </div>
      );
    }

    return (
      <>
        <div className="top-bar-profile-panel-container colour-dark-shade" onClick={ () =>
        {
          if( !this.state.showDropdown )
          {
            analytics.track( 'topBarProfileDropdown' )
          }

          this.setState( { showDropdown: !this.state.showDropdown } );
        } }>

          <img className="top-bar-profile-avatar" src={ process.env.PUBLIC_URL + '/avatars/meeple-ui-circle-player-white.png' } alt="Avatar icon" />

          <div className="top-bar-profile-username">{ username }</div>
          <div className="top-bar-profile-karma-score">Karma: { karmaScore }/{ karmaTotal }</div>

          <img className="top-bar-profile-dropdown-arrow" src={ process.env.PUBLIC_URL + '/ui/icon-down-arrow.png' } alt="Dropdown arrow" />

          {
            this.state.showDropdown &&
            <UserProfileDropdownPopup
              username={ sessionUsername }
              onEditUsernameRequested={ this.onEditUsernameRequested }
              onLoginRequested={ this.onLoginRequested }
              onLogout={ this.onAccountLogout }
            />
          }

        </div>

        {
          this.state.showEditUsernameOverlay &&
          <EditUsernamePopup close={ this.onUsernameChangeClosed } value={ sessionUsername } changeUsername={ this.onUsernameChangeClosed } sessionUsernameChangesRemaining={ sessionUsernameChangesRemaining } />
        }

        {
          this.state.showLoginOverlay &&
          <LoginOptionsPopup
            close={ this.onLoginOverlayClosed }
            onGoogleLogin={ this.onGoogleLogin } />
        }
      </>


    );
  }
};
